export default __webpack_public_path__ + "static/ui-vs-visual-design-ca3cfd396158a11bf80516276f5c7707.png";